import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CalculatorCard = ({ 
  title, 
  description, 
  icon, 
  features, 
  isActive, 
  onClick,
  completionRate = 0,
  estimatedTime 
}) => {
  return (
    <div 
      className={`card-elevated rounded-xl p-6 cursor-pointer transition-all duration-300 ${
        isActive 
          ? 'ring-2 ring-accent shadow-executive-hover scale-[1.02] bg-card border-accent/20' 
          : 'hover:shadow-executive-hover hover:scale-[1.01] bg-card border-border'
      }`}
      onClick={onClick}
    >
      <div className="flex items-start justify-between mb-4">
        <div className={`w-12 h-12 rounded-lg flex items-center justify-center shadow-sm ${
          isActive ? 'bg-accent text-accent-foreground' : 'bg-muted'
        }`}>
          <Icon 
            name={icon} 
            size={24} 
            color={isActive ? 'var(--color-accent-foreground)' : 'var(--color-text-primary)'} 
          />
        </div>
        {completionRate > 0 && (
          <div className="flex items-center space-x-2">
            <div className="w-16 h-2 bg-muted rounded-full overflow-hidden">
              <div 
                className="h-full bg-accent transition-all duration-500"
                style={{ width: `${completionRate}%` }}
              />
            </div>
            <span className="text-xs text-text-secondary">{completionRate}%</span>
          </div>
        )}
      </div>

      <h3 className="font-headline font-semibold text-lg text-text-primary mb-2">
        {title}
      </h3>
      
      <p className="text-text-secondary text-sm mb-4 leading-relaxed">
        {description}
      </p>

      <div className="space-y-2 mb-4">
        {features?.map((feature, index) => (
          <div key={index} className="flex items-center space-x-2">
            <Icon name="Check" size={16} color="var(--color-success)" />
            <span className="text-sm text-text-secondary">{feature}</span>
          </div>
        ))}
      </div>

      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2 text-text-secondary">
          <Icon name="Clock" size={16} color="var(--color-text-secondary)" />
          <span className="text-sm">{estimatedTime}</span>
        </div>
        
        <Button
          variant={isActive ? "default" : "outline"}
          size="sm"
          className={isActive ? "bg-accent hover:bg-accent/90 text-accent-foreground border-0" : "hover:border-accent hover:text-accent"}
        >
          {isActive ? 'Continue' : 'Start'}
        </Button>
      </div>
    </div>
  );
};

export default CalculatorCard;